import React from 'react';
import { VpnKeyOutlined } from '@mui/icons-material';

import type { CapsuleDto } from 'new/stores/capsules/capsules.endpoints';
import styles from './KeysSection.module.scss';

interface KeysSectionProps {
  capsule: CapsuleDto;
}

export function KeysSection({ capsule }: KeysSectionProps) {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <span className={styles.headerIcon}>
          <VpnKeyOutlined fontSize="small" />
        </span>
        <h2 className={styles.headerTitle}>Keys</h2>
      </div>
      <div className={styles.body}>
        <div className={styles.keysList}>
          <div className={styles.keysRow}>
            <span className={styles.keyLabel}>API Access Key</span>
            <span className={styles.masked}>
              {capsule.api_access_key?.trim() ? capsule.api_access_key : '—'}
            </span>
          </div>
          <div className={styles.keysRow}>
            <span className={styles.keyLabel}>Encryption/Decryption Key</span>
            <span className={styles.masked}>
              {capsule.registration_key?.trim() ? capsule.registration_key : '—'}
            </span>
          </div>
        </div>
        <span className={styles.caption}>Keys are not retrievable after initial generation.</span>
      </div>
    </div>
  );
}
